import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Your career highlights your success in driving digital transformation
                initiatives.What are the key pillars of your digital transformation strategy, and
                how do you prioritize modernization efforts within the bank?
              </strong>
            </h5>

            <h5 className="text-white">
              It is not one size fits all, so key pillars could be common but vary in impact weight
              from transformation journey to another. There are four 4 factors to spotlight: 1)
              Strategy-driven, ensuring bank wide strategy is transformational, 2) Value-drive,
              quantifying each initiative in value-stream mapping, 3) Collaboration, boosting
              co-working and cross—functional delivery, and 4) Agility, motivating innovations by
              lean process of incremental changes and out of the box ideas.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Agile methodologies have become critical in driving innovation. How is Suez Canal
                Bank adopting agile practices to enhance digital initiatives and customer-centric
                services?
              </strong>
            </h5>
            <h5 className="text-white">
              Agility as a practice of ways of working in the bank enabling early feedback from both
              external and internal customers, hence improvements and unblocking impediments are
              faster. In addition to, the value of autonomous cross-functional teams which increase
              ownership and commitments.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With increasing digital adoption, cybersecurity is more critical than ever. How do
                you balance the need for innovation with maintaining robust cybersecurity
                frameworks?
              </strong>
            </h5>
            <h5 className="text-white">
              Cybersecurity and modern digital & AI are both sides of one coin to buy the right
              approach of digitizing pieces of the transformation journey. The balance is neutral
              and secured by proper investment in both.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Cloud technology plays a vital role in digital transformation. How are you
                leveraging cloud solutions to drive operational efficiency and scalability at Suez
                Canal Bank?
              </strong>
            </h5>
            <h5 className="text-white">
              Cloud adoption has multiple flavors, our focus on private cloud hosting and
              cloud-native development through micro-services architecture modernization are the
              core. Over the time, upon regulations enablement to public cloud in banking sector the
              readiness would subject to the former points.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Innovation is key to staying competitive. What emerging technologies are you
                exploring to future-proof the bank’s digital services?
              </strong>
            </h5>
            <h5 className="text-white">
              Innovative solutions could be achieved with fundamental enablements, however recently
              the advanced technology specially in AI is extremely changing. Hence, GenAI and using
              LLM is one of the most focus areas in multiple use cases towards optimization in
              resources utilization and accelerate decision-making.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- With increasing reliance on digital channels, cybersecurity is a top priority.
                What are your key strategies for safeguarding customer data and ensuring regulatory
                compliance?
              </strong>
            </h5>
            <h5 className="text-white">
              Reference to previous discussion, investment in cybersecurity is aligned with
              releasing digital platforms focusing on multiple aspects starting from development
              lifecycle by DevSecOps, securing infrastructure, communication and application till
              observability of secure use.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Collaboration is essential for driving innovation. How do partnerships with
                fintech companies and technology providers accelerate digital transformation at Suez
                Canal Bank?
              </strong>
            </h5>
            <h5 className="text-white">
              Recently, FinTechs partnership is very important to all banks growth to assure
              co-creation, referrals, integration, … etc. Hence, banks should avail the right setup
              of technology as well as wide range of collaboration business models.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Closing Remark- As a speaker at Finnovex North Africa on April 23rd, what key
                message or insight would you like to share with the audience about the role of
                digital transformation in shaping the future of banking in the region?
              </strong>
            </h5>
            <h5 className="text-white">
              The crystal-clear fact admits that banks are backbone of the Egyptian economy, hence
              economy growth would require banks to adapt new ways of working as well as introducing
              new convenience products / services to all bank customers’ segments. The futuristic
              banking of neobanks, digital financial services, digital signature, eKYC,
              instant/behavioral lending, optimized fraud protection, and other use cases would
              require dedication and commitment to digital transformations programs.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
